import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [name, setName] = useState('');
  const { login, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await login(email, password);
    if (success) navigate('/dashboard');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>💰 Controle Financeiro</h1>
        <p className="subtitle">Gerencie suas finanças com inteligência</p>
        <form onSubmit={handleSubmit}>
          {!isLogin && <input type="text" placeholder="Nome" value={name} onChange={(e) => setName(e.target.value)} className="input-field" />}
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-field" required />
          <input type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} className="input-field" required />
          <button type="submit" className="btn-primary" disabled={loading}>{loading ? 'Carregando...' : (isLogin ? 'Entrar' : 'Cadastrar')}</button>
        </form>
        <p className="toggle-mode">{isLogin ? 'Não tem conta? ' : 'Já tem conta? '}<button type="button" onClick={() => setIsLogin(!isLogin)} className="btn-link">{isLogin ? 'Cadastre-se' : 'Faça login'}</button></p>
      </div>
    </div>
  );
}
